/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-slider-marker',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoSliderMarkerComponent extends NestedOption {
    @Input()
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    @Input()
    get customizeText(): Function {
        return this._getOption('customizeText');
    }
    set customizeText(value: Function) {
        this._setOption('customizeText', value);
    }

    @Input()
    get font(): DevExpress.viz.Font {
        return this._getOption('font');
    }
    set font(value: DevExpress.viz.Font) {
        this._setOption('font', value);
    }

    @Input()
    get format(): DevExpress.ui.format | string {
        return this._getOption('format');
    }
    set format(value: DevExpress.ui.format | string) {
        this._setOption('format', value);
    }

    @Input()
    get invalidRangeColor(): string {
        return this._getOption('invalidRangeColor');
    }
    set invalidRangeColor(value: string) {
        this._setOption('invalidRangeColor', value);
    }

    @Input()
    get paddingLeftRight(): number {
        return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value: number) {
        this._setOption('paddingLeftRight', value);
    }

    @Input()
    get paddingTopBottom(): number {
        return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value: number) {
        this._setOption('paddingTopBottom', value);
    }

    @Input()
    get placeholderHeight(): number {
        return this._getOption('placeholderHeight');
    }
    set placeholderHeight(value: number) {
        this._setOption('placeholderHeight', value);
    }

    @Input()
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }


    protected get _optionPath() {
        return 'sliderMarker';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoSliderMarkerComponent
  ],
  exports: [
    DxoSliderMarkerComponent
  ],
})
export class DxoSliderMarkerModule { }
